import { createSlice } from '@reduxjs/toolkit';
import { doGetOrderTickets } from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('OrderTickets/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('OrderTickets/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('OrderTickets/') && action.type.endsWith('/rejected');
};

const orderTicketsSlice = createSlice({
  name: 'orderTickets',
  initialState: {
    action: null,
    isFetching: false,
    orderTickets: null,
    status: 'idle',
    metadata: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetOrderTickets.pending, (state) => {
      state.action = 'getOrderTickets';
      state.status = 'loading';
    });
    builder.addCase(doGetOrderTickets.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.orderTickets = action.payload;
    });
    builder.addCase(doGetOrderTickets.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

const { reducer: OrderTicketsReducer } = orderTicketsSlice;
export default OrderTicketsReducer;
